import { render, staticRenderFns } from "./home.vue?vue&type=template&id=fa39f9e8&scoped=true"
import script from "./home.vue?vue&type=script&lang=ts"
export * from "./home.vue?vue&type=script&lang=ts"
import style0 from "./home.vue?vue&type=style&index=0&id=fa39f9e8&prod&lang=css"
import style1 from "./home.vue?vue&type=style&index=1&id=fa39f9e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa39f9e8",
  null
  
)

export default component.exports